/** REST API base URL including `/api` suffix. Set via REACT_APP_API_URL at build time. */
export function getApiBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_API_URL?.trim();
  if (fromEnv) {
    return fromEnv.endsWith('/') ? fromEnv.slice(0, -1) : fromEnv;
  }
  return process.env.NODE_ENV === 'production'
    ? 'https://tigersoft.online/api'
    : 'https://localhost:7055/api';
}

/** Host root for SignalR hubs (strips trailing `/api`). */
export function getHubBaseUrl(): string {
  return getApiBaseUrl().replace(/\/api\/?$/i, '');
}

export function getGameBoardHubUrl(): string {
  return `${getHubBaseUrl()}/hubs/gameboard`;
}
